module.exports = __webpack_public_path__ + "img/img12.fb2af788.png";